import React from 'react'
import Navbar from '../components/Navbar'
import Form from '../components/BuyForm'
import BuyForm from '../components/BuyForm'
import Transactions from '../components/Transactions'

const History = () => {
  return (
    <div>
        <Navbar/>
        <Transactions/>
    </div>
  )
}

export default History